export class FeatureFlagResponse {
    constructor(public name: string, public value = false, public canaryDeploymentOptions: string[] = []) {
    }
}
